import {
  useState,
  useEffect,
} from 'react';
import { Popover } from 'react-tiny-popover';

import {
  WorkoutExercise,
} from '@gymcloud/core';

import {
  Tooltip,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';

type Props = {
  number: number,
  numbers: number[],
  readOnly?: boolean,
  exercise: WorkoutExercise,
  onChange: { (exerciseId: number, newOrder: number): void },
};

const ExerciseOrder = ({
  number,
  numbers,
  readOnly = false,
  exercise,
  onChange,
}: Props) => {
  const [uniqueNumbers, addNumber] = useState<number[]>([])

  useEffect(() => {
    addNumber(
      Array.from(new Set(numbers))
    )
  }, [numbers])

  const [isOpen, setIsOpen] = useState(false);
  return readOnly ? (
    <S.OrderName
      number={number}
    >
      {exercise.order_name}
    </S.OrderName>
  ) : (
    <Popover
      transform={{ left: 10 }}
      transformMode="relative"
      content={(
        <S.ExerciseOrder>
          <Flex
            align="center"
            spacing={5}
          >
            {uniqueNumbers.map(item => (
              <S.NumberContainer
                key={item}
                number={item}
                onClick={() => {
                  if (number !== item) onChange(exercise.id, item);
                  setIsOpen(false);
                }}
              >
                {item}
              </S.NumberContainer>
            ))}
            {uniqueNumbers.length < 26 && (
              <S.Add
                onClick={() => {
                  addNumber([
                    ...uniqueNumbers,
                    uniqueNumbers[uniqueNumbers.length - 1] + 1,
                  ]);
                }}
              />
            )}
          </Flex>
        </S.ExerciseOrder>
      )}
      isOpen={isOpen}
      positions={['right']}
      onClickOutside={() => setIsOpen(false)}
    >
      <S.PopoverTrigger onClick={() => setIsOpen(!isOpen)}>
        <Tooltip
          positions={['top']}
          body="Create supersets by assigning the same number/color to exercises."
        >
          <S.OrderName
            number={number}
          >
            {exercise.order_name}
          </S.OrderName>
        </Tooltip>
      </S.PopoverTrigger>
    </Popover>
  );
};

export default ExerciseOrder;
